import { TOGGLE_FILTER } from '../../../constants/ActionTypes';
import makeBooleanToggle from '../../../higher_order_reducers/boolean_toggle';

const reducer = makeBooleanToggle(false, [TOGGLE_FILTER]);

export default reducer;



// WEBPACK FOOTER //
// ./src/components/filter/reducer/isFilterExpanded.js